import { render, staticRenderFns } from "./ModalMask.vue?vue&type=template&id=0a88d7b0&scoped=true"
import script from "./ModalMask.vue?vue&type=script&lang=js"
export * from "./ModalMask.vue?vue&type=script&lang=js"
import style0 from "./ModalMask.vue?vue&type=style&index=0&id=0a88d7b0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a88d7b0",
  null
  
)

export default component.exports